import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import RepurchaseTable from "../../components/shopping/RepurchaseTable";
import { ApiHook } from "../../hooks/apiHook";

const StripeSubscriptionReport = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortOptions, setSortOptions] = useState({
    sortBy: "",
    direction: ""
  });

  const report = ApiHook.CallStripeSubscriptionReport(currentPage, itemsPerPage, sortOptions.sortBy, sortOptions.direction);

  const headers = ["", "subscriptionId", "packageName", "status", "amount", "fee", "totalAmount", "currentPeriodStart", "currentPeriodEnd", "date"];
  const reportHeaders = [
    "", t("subscriptionId"), t("packageName"), t("status"), t("amount"),
    t("fee"), t("totalAmount"), t("currentPeriodStart"), t("currentPeriodEnd"), t("date")
  ];

  return (
    <>
      <div className="page_head_top">{t("stripe_subscription_report")}</div>
      <RepurchaseTable
        data={report.data}
        type={"stripe-subscription-report"}
        headers={headers}
        reportHeaders={reportHeaders}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        setSortOptions={setSortOptions}
      />
    </>
  );
};

export default StripeSubscriptionReport;
